<template>
	<div id="showdocs">
		<b-container fluid>
			<h1>
				<span>Documents</span
				><span @click="download" class="dl" v-if="docUrl"
					><v-icon name="download" scale="2"
				/></span>
			</h1>
			<b-row>
				<b-col cols="4">
					<b-card class="l10">
						<DxTreeList
							id="tasks"
							:data-source="dataSource"
							:show-borders="true"
							:column-auto-width="true"
							:word-wrap-enabled="true"
							key-expr="id_file"
							parent-id-expr="id_parent"
						>
							<DxSearchPanel :visible="true" :width="250" />
							<DxHeaderFilter :visible="true" />
							<DxColumnChooser :enabled="false" />

							<DxColumn :width="350" data-field="path" />
							<DxColumn
								:width="180"
								caption="Choose"
								data-field="c"
								cell-template="radioTemplateC"
							/>
							<template #radioTemplateC="{ data: d }">
								<b-button
									@click="view(d.data.id_file, d.data.size)"
									v-if="!d.data.isdir || d.data.path.includes('.zip')"
									:disabled="!enabled"
									><v-icon name="regular/eye" />
									{{ d.data.path.includes('.zip') ? "Download Zip" : ( d.data.size > PDFSIZELIMIT ? "Download Doc" : "View Doc" ) }}
                                </b-button>
							</template>
						</DxTreeList>
					</b-card>
				</b-col>
				<b-col cols="8">
					<b-card class="marspdfview">
						<pdf
							:_page="pdfpage"
							@_num-pages="pdfpages = $event"
							_src="Gefran_1600-1800_d.pdf"
							v-for="i in pdfpages"
							:key="i"
							:src="pdfsrc"
							:page="i"
							style="display: inline-block; width: 100%"
						>
						</pdf>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import {
	DxTreeList,
	DxColumn,
	DxColumnChooser,
	DxHeaderFilter,
	DxSearchPanel,
	// DxSelection,
} from "devextreme-vue/tree-list";
// import { tasks, employees, priorities } from './data.js';
import { API } from "@/api.js";
import pdf from "vue-pdf";

const development = process.env.NODE_ENV === "development";
const SERVER = development ? "http://localhost:81" : location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");

export default {
	components: {
		DxTreeList,
		DxColumn,
		DxColumnChooser,
		DxHeaderFilter,
		DxSearchPanel,
		pdf,
	},
	props: {
		m: Object,
	},
	data() {
		return {
			PDFSIZELIMIT: 1024 * 1024 * 5,
			components: [],
			pdfpage: 2,
			pdfpages: 0,
			pdfsrc: undefined,
			docUrl: false,
			enabled: true,
		};
	},
	mounted() {
		this.init();
	},
	computed: {
		SERVER() {
			return SERVER;
		},
		dataSource() {
			return this.components;
		},
	},
	methods: {
		async download() {
			// ATTENZIONE: funziona solo online, in debug c'è un problema di same origin
			const a = document.createElement("a");
			a.href = this.docUrl;
            console.log("a.href", this.docUrl);
			let download = this.docUrl
				.split("?")
				.pop()
				.split("&")[1]
				.split("=")
				.pop()
				.split("/")
				.pop();
			a.setAttribute("download", download);
			console.log("a.download", download);
			a.target = "_blank";
			a.style.display = "none";
			document.body.appendChild(a);
			//   a.click();
			a.dispatchEvent(new MouseEvent("click"));
			document.body.removeChild(a);
		},
		async view(doc, size) {
			let zfile = doc;
            console.log("view doc", zfile);
            doc = this.components.find((c) => c.id_file == zfile);
            while (doc.id_parent != this.m.codice) {
                doc = this.components.find(
                    (c) => c.id_file == doc.id_parent
                );
            }
            console.log("parent...", doc.id_file);
			if (size > this.PDFSIZELIMIT || zfile.includes(".zip")) {
				this.docUrl = API.getDocCall(this.m.codice, zfile, doc.id_file);
                console.log("call", this.docUrl);
                console.log("params", this.m.codice, zfile, doc.id_file);
				this.download();
				return;
			} else {
				this.enabled = false;
				// http://localhost:81/getDoc?code=K14251&file=2022-06-07_K14250/AUSF%C3%9CHRLICHE%20ANWEISUNGEN%20ZUM%20GEBRAUCH%20DER%20DOKUMENTATION.pdf&zip=2022-06-07_K14250.zip&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTIwNywibmFtZSI6ImFkbWluIiwic3VybmFtZSI6ImFkbWluIiwibG9naW4iOiJhZG1pbiIsInBhc3N3b3JkIjoiKjIxMjMyZjI5N2E1N2E1YTc0Mzg5NGEwZTRhODAxZmMzIiwiZW1haWwiOiJhZG1pbkBtYXJzaWxsaS5jb20iLCJjbGllbnRfY29kZSI6bnVsbCwibWFzdGVyIjp0cnVlLCJpYXQiOjE2NTcyMDc1MTAsImV4cCI6MTY1NzI5MzkxMH0.MmSIlzSlrx8F_UcFWURzFoDjRQj7oJtNDQcldfL2DCg
				this.docUrl = API.getDocCall(this.m.codice, zfile, doc.id_file);
				console.log("call", this.docUrl);
				//   let ret = await API.getDoc(this.m.codice, zfile, doc.id_file);
				//   console.log("RET!!", ret);
				var loadingTask = pdf.createLoadingTask(
					API.getDocCall(this.m.codice, zfile, doc.id_file)
				); //"Gefran_1600-1800_d.pdf");
				loadingTask.promise.then((pdf) => {
					this.pdfpages = pdf.numPages;
					// se cambio in fretta il viewer si incatorcia
					setTimeout(() => {
						this.enabled = true;
					}, 2000);
				});
				this.pdfsrc = loadingTask;
			}
		},
		async init() {
			// console.log("M", this.m);
			let res = await API.getDocs(this.m.codice);
			this.components = res;
			// console.log("documents", this.components);
		},
	},
};
</script>
<style>
#showcomps img.pointer {
	cursor: pointer;
}
#tasks {
	max-height: calc(100vh - 290px);
	height: calc(100vh - 290px);
}

#tasks .dx-treelist-rowsview td {
	vertical-align: middle;
}
#showdocs button path {
	fill: white;
}
</style>
<style scoped>
h1 span.r {
	float: right;
	fill: white;
}
td {
	padding: 5px;
}
div.marspdfview {
	max-height: calc(100vh - 248px);
	height: calc(100vh - 248px);
	overflow: auto;
	right: 10px;
}
span.dl {
	float: right;
	margin-right: 80px;
	cursor: pointer;
}
div.l10 {
	left: 10px;
}
</style>
